// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GvPm","rootMobile":"styles_rootMobile__3dpxn"};